import React from "react";

import BlogHeroHome from "../BlogGridHome/BlogHeroHome/BlogHeroHome";
import PostItemSimple from "./PostItemSimple/PostItemSimple";
import LowerSidebarCtaContainer from "@containers/LowerSidebarCtaContainer";

import styles from "./MoreStories.module.scss";

type IMoreStories = {
  posts: Queries.WpPostConnection["nodes"];
  isNotMainPage?: boolean;
  className?: string;
};

const MoreStories: React.FC<IMoreStories> = ({
  posts,
  isNotMainPage = false,
  className = "",
}) => {
  const blogHero = posts.length > 0 && posts[0];
  const postsMoreStories = !isNotMainPage
    ? posts?.slice(1, posts.length - 1)
    : posts;

  const containerClasses = `${styles.moreStoriesContainer} ${className}`;
  const blogGridClasses = isNotMainPage
    ? styles.moreStoriesBlogGrid
    : `${styles.moreStoriesBlogGrid} ${styles.pollenGrid}`;
  const titleClasses = isNotMainPage
    ? `${styles.moreStoriesTitle} ${styles.postPage}`
    : styles.moreStoriesTitle;

  return (
    <div className={containerClasses}>
      <h2 className={titleClasses}>More Stories</h2>
      <div className={blogGridClasses}>
        {!isNotMainPage && (
          <div className={styles.bcard}>
            {blogHero && <BlogHeroHome blogHero={blogHero} />}
          </div>
        )}
        <div className={styles.bside}>
          <LowerSidebarCtaContainer />

          {postsMoreStories?.map((post, index) => (
            <PostItemSimple key={index} post={post} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default MoreStories;
